import React, { createContext, useState, useEffect } from "react";
import { getAdmittedPatients } from "../services/getAdmittedPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const AdmittedContext = createContext();

export const AdmittedProvider = ({ children }) => {
  const [admittedPatients, setAdmittedPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [memberType, setMemberType] = useState(null);

  const { token, isValid, authLoading } = useValidToken();

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getAdmittedPatients(null, locationId, memberType);
        setAdmittedPatients(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, locationId, memberType]);

  return (
    <AdmittedContext.Provider value={{
      admittedPatients,
      loading,
      error,
      setLocationId,
      setMemberType,
    }}>
      {children}
    </AdmittedContext.Provider>
  );
};
